import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AttributeValue } from '../../../../../models/section-definition.model';

@Component({
  selector: 'lib-attribute-location-row',
  standalone: false,
  templateUrl: './attribute-location-row.component.html',
  styleUrls: ['./attribute-location-row.component.scss'],
})
export class AttributeLocationRowComponent {
  @Input() attributeValue!: AttributeValue;
  @Output() mapClicked = new EventEmitter<AttributeValue>();

  onMapClick() {
    this.mapClicked.emit(this.attributeValue);
  }
}
